import { Component, OnInit } from '@angular/core';
import { Location, LocationService } from "services/location.service";
import { MetaService } from 'services/meta.service';
import { CueWidgetService } from 'services/cue-widget.service';

@Component({
	selector: 'ras-home-page',
	templateUrl: './home-page.component.html',
	styleUrls: ['./home-page.component.sass']
})
export class HomePageComponent implements OnInit {

	locations: Location[] = []

	// Seasonal Christmas banners - randomly selected on each page load
	// Using optimized images (95-99% smaller file sizes!)
	banners = [
		{
			image: '/assets/banners-optimized/rasbanner11.jpg',
			imageWebp: '/assets/banners-optimized/rasbanner11.webp',
			position: 'center',
			focusY: '40%',
			topText: 'When your wife says:',
			topText2: '"Get rid of them!!"',
			mainText: "We'll take care of it."
		},
		{
			image: '/assets/banners-optimized/rasbanner12.jpg',
			imageWebp: '/assets/banners-optimized/rasbanner12.webp',
			position: 'center',
			focusY: '30%',
			topText: "I'll fit into it again...",
			topText2: null,
			mainText: "We'll take care of it."
		},
		{
			image: '/assets/banners-optimized/rasbanner13.jpg',
			imageWebp: '/assets/banners-optimized/rasbanner13.webp',
			position: 'center',
			focusY: '35%',
			topText: '"Comic Con is only',
			topText2: 'once a year"',
			mainText: "We'll take care of it."
		},
	];
	banner: any = null;

/*	generic_unit_index: null|number = null
	generic_units: null|string[] = null
	generic_areas: null|string[] = null
	index_event(event){
		this.generic_unit_index = event
	}
*/
	constructor(
		private locationService: LocationService,
		private meta: MetaService,
		private cueWidget: CueWidgetService
	) { }

	ngOnInit() {
		this.meta.apply('home')

		// Track home page visit in Cue widget
		this.cueWidget.updateSessionData({
			page: 'home',
			source: 'website'
		});

		// Randomly select a banner on each page load
		if (this.banners.length > 0) {
			let banner_i = Math.floor(Math.random()*this.banners.length);
			this.banner = this.banners[banner_i];
		}

		this.locationService.get_all()
		.then(locations => {
			this.locations = locations
		})
	}

}
